import axios from "axios";
import { keycloak } from "../../lib/keycloak/index";
import { CustomerService } from "./service";
import { ConsentDTO, CreateCustomerRequestDTO, CustomerActiveDTO, CustomerDTO, CustomerFiltersDTO, EditCustomerRequestDTO, FindAllCustomersResponseDTO, PurchaseDTO } from "./dto";

export class CustomerServiceImpl implements CustomerService {
    public changeStatus(id: string, request: CustomerActiveDTO): Promise<void> {
        let url: string = "/api/customer/status/" + id
        return axios({
            url: url,
            method: "PUT",
            data: request,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
    public deleteCustomer(id: string): Promise<void> {
        let url: string = "/api/customer/" + id
        return axios({
            url: url,
            method: "DELETE",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then(() => undefined)
    }
    public editCustomer(id: string, request: EditCustomerRequestDTO): Promise<void> {
        let url: string = "/api/customer/" + id
        return axios({
            url: url,
            method: "PUT",
            data: request,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
    public findCustomerById(id: string): Promise<CustomerDTO> {
        let url: string = "/api/customer/" + id
        return axios({
            url: url,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
    public findAllCustomers(filters: CustomerFiltersDTO): Promise<FindAllCustomersResponseDTO> {
        let url: string = "/api/customer?" +
            "pageSize=" + filters.itemsPerPage +
            "&sortBy=" + filters.sortBy +
            "&page=" + filters.page +
            "&sort=" + filters.sort +
            "&name=" + filters.name
        return axios({
            url: url,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
    public createCustomer(request: CreateCustomerRequestDTO): Promise<void> {
        let url: string = "/api/customer"
        return axios({
            url: url,
            method: "POST",
            data: request,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public otpRequest(request: {
        duration: number
        mail: string
    }): Promise<void> {
        let url: string = "/otp/request"
        return axios({
            url: url,
            method: "POST",
            data: request,
            headers: {
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public otpValidate(consents: ConsentDTO): Promise<string> {
        let url: string = "/otp/validate"
        return axios({
            url: url,
            method: "POST",
            data: consents,
            headers: {
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}
